import $axios from '@/axios-instance.js'

export const tagService = {
  getAll,
  getById,
  create,
  update,
  delete: _delete
}

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/tags/get-all`).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/tags/${id}`).then(response => {
    return response.data
  })
}

function create (tag) {
  return $axios.post(`${process.env.ROOT_API}/tags`, tag).then(response => {
    return response.data
  })
}

function update (tag) {
  return $axios.put(`${process.env.ROOT_API}/tags/${tag.tagId}`, tag).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/tags/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/tag.service.js